const getDefaultTxPackage = () => {
  return {
    title: '(Please Edit)',
    present_method: 'all',
    pages: [],
  }
}
export default getDefaultTxPackage
